import { useProductCard } from 'product-card/hooks/useProductCard'

const DEFAULT_LOOK_ID = '00'

export const useProductImages = () => {
	const { product, lookId, selectedColorId } = useProductCard()

	const { colors } = product
	const targetColor = colors.find((element) => element.id === selectedColorId)

	if (!targetColor) {
		// Do not return images if the target color is not found
		return {}
	}

	const { images } =
		targetColor.looks[lookId] || targetColor.looks[DEFAULT_LOOK_ID]

	return images
}
